import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import { listOrganizationsUrl } from "../../config";
import { RootState } from "../../store";
import api from '../../api';
import { IOrganizations, IOrganizationsApi } from "../../common/types/groupTypes";

const GET_ORGANIZATIONS = "getOrganizations"

const initialState: IOrganizations = {
  organizations: {} as IOrganizationsApi | null,
  status: Status.IDLE,
  error: null,
};

export const fetchOrganizationData = createAsyncThunk(
  GET_ORGANIZATIONS,
  async () => {
  try {
    const response = await api.get(listOrganizationsUrl);
    const organizationsData: IOrganizationsApi = response.data;
    return organizationsData;
  } catch (error) {
    throw error;
  }
}
);

const organizationsSlice = createSlice({
  name: GET_ORGANIZATIONS,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganizationData.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(fetchOrganizationData.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.organizations = action.payload;
      })
      .addCase(fetchOrganizationData.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
      });
  },
});

export const selector = (state: RootState) => state.organizationsApi;

export const reducer = organizationsSlice.reducer;
